<div class="shop-product" [style.height]="height" [style.marginBottom]="margin" #shopItem [class.active]="selected" [formGroup]="form">
	<img *ngIf="image" [src]="image" [alt]="product.name">
	<h2 [innerHTML]="product.name"></h2>
	<div class="row column">
		<div class="giftshop-button-wrapper">
			<div class="giftshop-price" *ngIf="freePrice === false">
				<a class="twingle-minus1" (click)="minus()" [title]="'giftshop.item.decrease' | translate"></a>
				<strong>{{product.price * itemCount | number: '1.0-0'}} {{currency}}</strong>
				<a class="twingle-plus1" (click)="plus()" [title]="'giftshop.item.increase' | translate"></a>
			</div>
			<div class="giftshop-price free-price" *ngIf="freePrice === true">
				<p class="infotext top" *ngIf="showErrorMessage()" [innerHTML]="'giftshop.item.freeprice.error' | translate"></p>
				<input type="number" required pattern="[0-9]+" [(ngModel)]="priceValue" formControlName="price" [placeholder]="'giftshop.item.freeprice.placeholder' | translate" min="1" max="14999">
				<span>{{currency}}</span>
			</div>
			<div class="giftshop-item-description" *ngIf="selected" #shopItemDescription>
				<p [innerHTML]="getDescription()"></p>
			</div>
			<button class="button" [class.grey]="validForm === false" [disabled]="validForm === false" [class.arrow]="selected" [class.arrow-right]="selected" (click)="selectItem()">{{(selected === true? 'giftshop.item.personalize' : 'giftshop.item.select') | translate}}</button>
		</div>
	</div>
</div>
